<ng-container *ngIf="this.selectedType!=''" class="">
  <div class="row"  [formGroup]="fieldForm">

      <span >
        <mat-form-field appearance="outline" #fieldInput required>
          <mat-label>Enter Field</mat-label>
          <input matInput formControlName="field" >
          <mat-error>
             <mat-error *ngIf="  fieldForm.get('field')?.invalid ">
        <span style="color: red;" *ngIf="fieldForm.get('field')?.errors?.required">*It is Required.</span>
      </mat-error>
          </mat-error>
        </mat-form-field>

&nbsp;      <button mat-stroked-button  color="primary" type="submit" (click)="AddTypData()">Add {{selectedType}}</button>
    </span>
  </div>
  <hr>
</ng-container>
